import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const UseAbleSlice = createSlice({
  name: "usebale",
  initialState,
  reducers: {},
});

export default UseAbleSlice.reducer;
